export default {
  bloodRed: '#D13823',
  softPink: '#FE576B',
  pink: '#FC889C',
  yellow: '#FFBB00',
  electricGreen: '#71DDAB',
  governorBayBlue: '#3C49CB',
  azurBlue: '#0264FF',
  softBlue: '#3283F9',
  bluishGrey: '#8B92AB',
  bluishWhite: '#E7E7FE',
  lightGrey: '#F8F8F8',
  pureWhite: '#ffffff',
  middleGrey: '#9B9B9B',
  mediumGrey: '#666666',
  darkGrey: '#4A4A4A',
  darkerGrey: '#2E3038',
  almostBlack: '#1D1D1B',
  midnightExpress: '#131A4C',
}
